<template>
    <div class="collectGoodList borderLine borderTop">
        <div class="titleBox fix">
            <span>最新送拍</span>
            <span class="fr sendBtn"  @click="sendButClick">我要送拍</span>
        </div>
        <div>
            <ul class="fix">
                <li v-for="(item,index) in list" :key="index" @click="itemClick(index)">
                    <div class="item">
                        <div class="imgBox">
                            <a class="pic" target="_blank">
                                <el-image style="" :src="item.CoverPic">
                                    <div slot="placeholder" class="image-slot">
                                        加载中<span class="dot">...</span>
                                    </div>
                                    <div slot="error" class="el-image__error">
                                        <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                    </div>
                                </el-image>
                            </a>
                        </div>
                        <a class="goodName yahei14 oneLineText">{{item.WorkName}}</a>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import {sendScData} from "@/utils/buriedPoint";

export default {
    name: "collectGoodList",
    props: ['list'],
    data(){
        return{
            dataList:[{},{},{},{},{}],
        }
    },
    methods:{
        sendButClick(){
            sendScData('ImmediatelySendPatClick',{
                current_page:location.href
            })
            this.$emit('sendGoodClick');
        },
        itemClick(index) {
            this.$emit('itemClick', 3, index)
        }
    }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/auctionCompany.scss";
.collectGoodList{
    padding: 35px 25px 0 25px;
    .titleBox{
        margin-bottom: 40px;
        display: block;
        font-size: 28px;
        font-family: "微软雅黑";
        font-weight: normal;
        color: #333;
        line-height: 32px;
        .sendBtn{
            display: inline-block;
            height: 32px;
            background: #f2f2f2;
            text-align: center;
            line-height: 32px;
            font-size: 12px;
            font-weight: normal;
            padding: 0px 20px;
            margin-right: 11px;
            cursor: pointer;
        }
    }
    ul{
        li{
            float: left;
            width: 148px;
            margin-right: 20px;
            margin-bottom: 20px;
            .imgBox{
                border: 1px solid #f2f2f2;
                width: 148px;
                height: 148px;
                text-align: center;
                background-color: transparent;
                .pic{
                    display: table-cell;
                    vertical-align: middle;
                    table-layout: fixed;
                    width: 148px;
                    height: 148px;
                }
            }
            .goodName{
                text-align: center;
                width: 100%;
                display: block;
                padding-top: 10px;
            }
        }
    }

}
</style>